/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-08 10:46:13
 * @LastEditTime: 2022-04-08 17:30:22
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\typeManage\request.js
 */
import request from '@/utils/request';

// 理赔类型-分页
export function claimsTypeList(data) {
  return request.post('admin/claims-type/list', data);
}

// 理赔类型-新增
export function claimsTypeAdd(data) {
  return request.post('admin/claims-type/store', data);
}

// 理赔类型-编辑
export function claimsTypeEdit(data) {
  return request.post('admin/claims-type/edit', data);
}
// 理赔类型-删除
export function claimsTypeDelete(data) {
  return request.post('admin/claims-type/delete', data);
}

// 理赔类型-详情
export function claimsTypeDetail(data) {
  return request.post('admin/claims-type/detail', data);
}

// 理赔类型-状态更新
export function claimsTypeUpdate(data) {
  return request.post('admin/claims-type/update', data);
}

// 理赔类型-资源
export function claimsTypeResource(data) {
  return request.post('admin/claims-type/resource', data);
}
// 理赔类型-资源(配置审核流)
export function auditFlowClaimsTypeResource(data) {
  return request.post('admin/audit-flow/claimsResource', data);
}
// 理赔类型-获取名称通过ID
export function claimsTypeName(data) {
  return request.post('admin/claims-type/get-name-by-id', data);
}